import React, {useEffect, useState} from "react";
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";
import {security,hosts} from "../env/Environment";
import {Ajax} from "../Service/ajax";
import {ClipLoader} from "react-spinners";
import Swal from "sweetalert2";
import WebSocketTest from "../Componants/WebSocketTest";
export default function PaymentView() {
    const navigate = useNavigate();
    const location = useLocation();
    const someData = JSON.parse(location.state?.someData);
    const session = sessionStorage.getItem("session");
    const solution = sessionStorage.getItem("solution");
    const url = window.location.pathname + window.location.search;
    const [prefix, setPrefix] = useState("243");
    const [suffix, setSuffix] = useState("");
    const [account, setAccount] = useState("");
    const [price, setPrice] = useState("");
    const [currency, setCurrency] = useState("CDF");
    const [full_name, setFull_name] = useState("");
    const [expiration_date, setExpiration_date] = useState("");
    const [control, setControl] = useState("");
    const [provider, setProvider] = useState({})
    const [providerInput, setProviderInput] = useState('');
    const [providers, setProviders]=useState([]);
    const[ref, setRef] = useState("");
    const[cnlUrl, setCnlUrl] = useState("");
    const [cfrmUrl, setCfrmUrl] = useState("");
    const [loading, setLoading] = useState(false);
    const continue_url=window.location.origin+"/payment-check?trs="+ref;
    const [isValidAccount, setIsValidAccount] = useState(false);
    const [showSocket, setShowSocket] = useState(false);
    const [placeHolder, setPlaceHolder] = useState("");
    const [initData, setInitData] = useState(null);
    const [converting, setConverting] = useState(false);
    const [processing, setProcessing] = useState(false);
    const [sol, setSol] = useState("");
    const [initialValues, setInitialValues] = useState(null);

    const callbackUrlRqsModel = {
        continue_url: continue_url,
        callback_url: cfrmUrl
    };

    async function loadConversion(amount, origin, target) {
        setConverting(true);
        try {
            const { data } = await Ajax.getRequest(`/exposed/v1/loc/conversion-rates/convert`, {
                params: {
                    origin: origin,
                    target: target,
                    amount: amount
                }
            });

            return data?.converted_amount ? parseFloat(data.converted_amount.toFixed(2)) : null;
        } catch (e) {
            console.error(e);
            return null;
        }finally {
            setConverting(false);
        }
    }

    const transactorRqsModel = {
        provider_id: providerInput,
        prefix: prefix,
        account: account,
        suffix: suffix,
        full_name: full_name,
        expiration_date: expiration_date,
        control: control
    };

    const paymentRqsModel = {
        company_id: someData.cmp,
        solution_id:sol,
        password: null,
        app_id: security.app_id,
        client_id: security.client_id,
        currency: currency,
        ref: ref,
        label: "souscription a l'abonnement "+someData.title,
        amount: price,
        callbackUrl: callbackUrlRqsModel,
        buyer: transactorRqsModel
    };

    const dataToSend={
        company_id: someData.cmp,
        currency: someData.currency,
        ref: ref,
        app_id: security.app_id,
        label: "souscription a l'abonnement "+someData.title,
        amount: someData.price,
        callbackUrl: {
            continue_url: continue_url,
            confirm_callback_url: cfrmUrl,
            cancel_callback_url: cnlUrl
        },
        buyer: {
            provider_id: providerInput,
            prefix: prefix,
            account: account,
            suffix: suffix,
            full_name: full_name,
            expiration_date: expiration_date,
            control: control
        }
    }

    function validateNumber(inputValue) {
        const regex = new RegExp(provider.account_format)
        if (regex.test(inputValue)) {
            setIsValidAccount(true)
            setAccount(inputValue);
        } else {
            setIsValidAccount(false)
            setAccount(inputValue);
        }
    }

    const formatPlaceholder = (text) => {
        const parts = text.split("ex:");
        if (parts.length === 2) {
            const label = parts[0].trim(); // "Numéro Airtel"
            const example = `Ex: ${parts[1].trim()}`; // "Ex: 970000000"
            return { label, example };
        }
        return { label: text, example: "" };
    };

    const handleSelectProvider = (e) =>{
        const provider = providers.find(prov => prov.id === e);
        setProvider(provider)
        setProviderInput(e)
        if(provider.provider_type === "MOBILE MONEY"){
            const { label, example } = formatPlaceholder(provider.description);
            console.log(provider.name);
            console.log(example);
            setPlaceHolder("Numero "+provider.name+" "+example);
        }else{
            console.log(provider.name);
            setPlaceHolder("Numero de compte"+provider.name);
        }
    }

    useEffect(() => {
        (async () => {
            console.log(`origin: ${someData.currency} target: ${currency}`);
            if (currency === "CDF" && someData.currency === "USD") {
                setPrice(someData.price);
                const cdfPrice = await loadConversion(someData.price, someData.currency, currency);
                if (cdfPrice !== null) {
                    setPrice(cdfPrice);
                }
            } else if(currency === "USD" && someData.currency === "CDF") {
                const usdPrice = await loadConversion(someData.price, someData.currency, currency);
                if (usdPrice !== null) {
                    setPrice(usdPrice);
                }
            }else {
                setPrice(someData.price);
            }
        })();
    }, [currency]);

    const handleSubmit = () => {
        const fetchData = async () => {

            try {
                setProcessing(true)
                const {data} = await Ajax.postRequest("/api/v1/sub/make", paymentRqsModel);
                console.log(data)
                console.log(paymentRqsModel)
                if(!data.error){
                    if(data.payment_link){
                        Swal.fire({
                            title: "Confirmer le paiement",
                            text: "Voulez-vous ouvrir la page de paiement dans un nouvel onglet ?",
                            icon: "question",
                            showCancelButton: true,
                            confirmButtonText: "Confirmer",
                            cancelButtonText: "Annuler",
                            customClass: {
                                popup: "custom-popup",
                                confirmButton: "custom-button",
                                cancelButton: "custom-cancel-button"
                            }
                        }).then((result) => {
                            if (result.isConfirmed) {
                                window.open(data.payment_link, "_blank"); // Ouvre le lien dans un nouvel onglet
                                window.history.back(); // Retour en arrière sur l'onglet courant
                            } else {
                                window.history.back(); // Retour en arrière si l'utilisateur annule
                            }
                        });
                    }else{
                        Swal.fire({
                            title: data.message,
                            text: `Votre demande d'abonnement a été initiée avec succès. Veuillez confirmer le paiement sur votre mobile pour finaliser.`,
                            icon: 'success',
                            confirmButtonText: 'OK',
                            timerProgressBar: true,
                            customClass: {
                                popup: 'custom-popup',
                                confirmButton: 'custom-button'
                            },
                            timer: 10000
                        }).then((result) => {
                            if (result.isConfirmed || result.dismiss === Swal.DismissReason.timer) {
                                window.history.back();
                            }
                        });
                    }
                }else{
                    Swal.fire({
                        title: 'Error!',
                        text: data.message,
                        icon: 'error',
                        confirmButtonText: 'OK',
                        customClass: {
                            popup: 'custom-popup',
                            confirmButton: 'custom-button'
                        },
                        timer: 5000
                    });
                }
            } catch (error) {
                Swal.fire({
                    title: 'Error!',
                    text:`Oups! Une erreur s'est produite, veuillez reesayer plus tard.`,
                    icon: 'error',
                    confirmButtonText: 'OK',
                    customClass: {
                        popup: 'custom-popup',
                        confirmButton: 'custom-button'
                    },
                    timer: 5000
                });
            }finally {
                setProcessing(false)
            }
        };
        if(!session){
            window.location.replace(window.location.origin+"/login?redirectUrl="+url);
        }else{
            fetchData();
        }
    }
    useEffect(() => {
        const dataInitPmt={
            sub_id:someData.id,
            infos:someData.infos || []
        }

        const fetchData = async () => {
            try {
                setLoading(true);

                // Récupérer les données de la solution
                const { data: solData } = await Ajax.getRequest('/exposed/v1/cmp/solutions?code=SUB');
                setSol(solData.id);

                // Initialiser le paiement
                const initPmt = await Ajax.postRequest("/api/v1/sub/subscription/initiate", dataInitPmt);
                console.log("init: ",initPmt);

                if (!initPmt.data.error) {
                    const { object } = initPmt.data;
                    setRef(object["pmt_id"]);
                    setCfrmUrl(hosts.api + "/exposed/v1/sub/" + object["callBackUrl"]["confirm_url"]);
                    setCnlUrl(hosts.api + "/exposed/v1/sub/" + object["callBackUrl"]["canceled_url"]);
                    setInitData(initPmt.data.object);
                }else{
                    navigate("/error-page");
                }

                // Récupérer les fournisseurs
                const { data: providerData } = await Ajax.getRequest("/api/v1/trs/providers", {
                    params: { pge: 1, typ: "all", opr: "PMT", lmt: 100, slug: "" }
                });
                setProviders(providerData.contents);

            } catch (error) {
                navigate("/error-page", { state: { errorCode: error.response.status } });
            } finally {
                setLoading(false);
            }
        };

        if(!session){
            window.location.replace(window.location.origin+"/login?redirectUrl="+url);
        }else{
            fetchData();
        }
    }, []);

    function handleCancel() {
        window.history.back();
    }

    return (
        <div className="container-md">
        <div className="authentication-wrapper cd-flex justify-content-center align-items-center">
            {loading? (
                <div className="spinner-border spinner-border-lg text-netikash" role="status">
                    <span className="visually-hidden">Chargement...</span>
                </div>
            ) : <div className="card">
                <div className="card-body">
                    <div className="app-brand justify-content-center">
                        <div className="mb-2">
                            <img src={require("../assets/img/illustrations/payment-app-vector-illustration.jpg")}
                                 alt="Netiaksh Logo" style={{width: 200}}/>
                        </div>
                    </div>
                    <h4 className="mb-4 text-netikash text-center">Confirmation de paiement!</h4>

                    <div className="row justify-content-center mb-4">
                        {/* Section gauche - Détails */}
                        <div className="col-md-6">
                            {initData && (
                                <div className="card p-3 shadow-sm">
                                    <div className="mb-2 d-flex justify-content-between">
                                        <p className="card-text fw-bold">Organisation:</p>
                                        <p className="card-text">{initData.cmp}</p>
                                    </div>
                                    <div className="mb-2 d-flex justify-content-between">
                                        <p className="card-text fw-bold">Abonnement:</p>
                                        <p className="card-text">{someData.title}</p>
                                    </div>

                                    {providerInput && <div className="mb-2 d-flex justify-content-between">
                                        <p className="card-text fw-bold">Provider:</p>
                                        <p className="card-text">{provider.name}</p>
                                    </div>}
                                    {isValidAccount && <div className="mb-2 d-flex justify-content-between">
                                        <p className="card-text fw-bold">Numero:</p>
                                        <p className="card-text">{account}</p>
                                    </div>}

                                    <div className="mb-2 d-flex justify-content-between">
                                        <p className="card-text fw-bold">Prix:</p>
                                        {converting ? (
                                            <div className="spinner-border spinner-border-sm text-netikash" role="status">
                                                <span className="visually-hidden">Chargement...</span>
                                            </div>
                                        ) : (
                                            <p className="card-text">{price} {currency}</p>
                                        )}
                                    </div>
                                </div>
                            )}
                        </div>

                        {/* Section droite - Formulaire */}
                        <div className="col-md-6">
                            <p className="mb-2">Veuillez remplir les différentes informations pour finaliser le paiement</p>
                            <div className="input-group mb-2">
                                <label className="input-group-text col-3" htmlFor="provider">Payer via</label>
                                <select className="form-select" id="provider" value={providerInput}
                                        onChange={(e) => handleSelectProvider(e.target.value)}>
                                    {!providerInput && <option>Selectionner ...</option>}
                                    {providers.map((item, index) => (
                                        <option key={index} value={item.id}>{item.name}</option>
                                    ))}
                                </select>
                            </div>
                            <div className="input-group mb-2">
                                <label className="input-group-text col-3" htmlFor="currency">Devise</label>
                                <select className="form-select" id="currency" value={currency}
                                        onChange={(e) => setCurrency(e.target.value)}>
                                    <option value="CDF">CDF</option>
                                    <option value="USD">USD</option>
                                </select>
                            </div>
                            {provider.with_account && (
                                <div className="input-group input-group-merge mb-2">
                                    <span className="input-group-text fw-bold">{prefix}</span>
                                    <input type="text" className="form-control"
                                           placeholder={placeHolder} value={account} id="account"
                                           onChange={(e) => validateNumber(e.target.value)} />
                                    <span className="input-group-text">
                                        {isValidAccount ?
                                            <i className='bx bx-check-double text-success'></i> :
                                            <i className='bx bx-x bx-burst text-danger'></i>}
                                    </span>
                                </div>
                            )}
                        </div>
                    </div>

                    {/* Bouton de confirmation */}
                    <div className="d-flex justify-content-start">
                        <div className="d-flex justify-content-start w-100">
                            <button
                                className="btn btn-outline-danger d-grid w-50 me-2"
                                onClick={handleCancel}
                            >
                                Annuler
                            </button>
                            <button
                                className={!isValidAccount && provider.with_account ?
                                    "btn btn-netikash d-grid w-50 disabled" :
                                    "btn btn-netikash d-grid w-50"}
                                onClick={handleSubmit}
                            >
                                {processing ? (
                                    <div className="d-flex justify-content-center align-items-center w-100">
                                        <div className="spinner-border spinner-border-sm text-primary" role="status">
                                            <span className="visually-hidden">Chargement...</span>
                                        </div>
                                    </div>
                                ) : "Confirmer le paiement"}
                            </button>
                        </div>
                    </div>

                </div>
            </div>}
            </div>
        </div>

    );
}
